/**
 * Toggle
 */

export default function Toggle() {
    const selectors = {
        'toggle' : '.js-toggle',
    };

    this.init = () => {
        jQuery(function ($) {
            jQuery(document).on('click', selectors.toggle, (e) => {
                e.preventDefault();
                let $this = jQuery(e.target);
                let elm = $this.data("target")
                jQuery(elm).slideToggle();
            })
        });

    };
}
